import { FiMenu } from "react-icons/fi";

const Navbar = () => {
  return (
    <header className="fixed top-0 left-0 w-full bg-white/90 backdrop-blur-md z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">

        {/* Logo */}

        {/* <div className="text-3xl font-black tracking-widest">
          TA
        </div> */}
        <img
                  src="/images/logo.png"
                  alt=""
                  className="h-[60px]"
                />

        {/* Menu */}

        <nav className="hidden lg:flex items-center gap-10 text-sm font-medium">

          <a href="#home" className="hover:text-red-500 transition">
            Home
          </a>

          <a href="#services" className="hover:text-red-500 transition">
            Services
          </a>

          <a href="#portfolio" className="hover:text-red-500 transition">
            Portfolio
          </a>

          <a href="#about" className="hover:text-red-500 transition">
            About
          </a>

          <a href="#testimonials" className="hover:text-red-500 transition">
            Testimonials
          </a>

          <button className="bg-red-500 hover:bg-red-600 text-white px-5 py-2 rounded-full transition">
            Call Now
          </button>

        </nav>

        <button className="lg:hidden text-3xl">
          <FiMenu />
        </button>

      </div>
    </header>
  );
};

export default Navbar;